import classNames from 'classnames';
import { useField } from 'formik';
import * as bd from 'react-basic-design';
import { NumberInput } from '../basic/number-input';
import { translate } from '../basic/text';

type FormikNumberInputProps = {
    isHidden?: boolean;
    label?: string | React.ReactNode;
    labelWidth?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
    //maxLabelWidth?: number | string;

    postfixLabel?: string | React.ReactNode;
    footer?: string | React.ReactNode;

    inputRef?: any;
    id?: string;
    type?:
        | 'textarea'
        | 'select'
        | 'text'
        | 'number'
        | 'email'
        | 'password'
        | 'search'
        | 'time'
        | 'url'
        | 'tel';
    inputClassName?: string;
    autoComplete?: 'on' | 'off';
    autoFocus?: boolean;
    spellCheck?: boolean;
    readOnly?: boolean;
    showErrorLabel?: boolean;

    buttonIcon?: React.ReactNode;
    buttonOnClick?: bd.Void;

    handleEnter?: boolean;

    maxLength?: number | string;
    className?: string;
    width?: number | string;
    maxWidth?: number | string;
    inputMaxWidth?: number | string;
    inputStyle?: React.CSSProperties;
    controlClassName?: string;
    [x: string]: any;
};

export const FormikNumberInput = ({
    isHidden,
    label,
    labelWidth,

    postfixLabel,
    footer,

    inputRef,
    id,
    type,
    inputClassName,
    autoComplete,
    autoFocus,
    spellCheck,
    readOnly,
    showErrorLabel,

    buttonIcon,
    buttonOnClick,

    handleEnter,

    maxLength,
    className,
    width,
    maxWidth,
    inputMaxWidth,
    inputStyle,
    controlClassName,
    onChange,
    ...props
}: FormikNumberInputProps) => {
    const [field, meta, helper] = useField({ name: props.name });
    if (isHidden) return null;
    if (!type) type = 'text';
    if (!autoComplete) autoComplete = 'off';
    if (!spellCheck) spellCheck = false;
    if (label && id === undefined) id = props.name;

    const displayValue = field.value;

    const onChangeHandler = (ev: any) => {
        if (onChange) onChange(ev);
        helper.setValue(ev.target.value);
    };

    if (!!inputMaxWidth) inputStyle = { ...inputStyle, maxWidth: inputMaxWidth };

    meta.error = translate(meta.error);

    if (footer) {
        postfixLabel = <small className="px-1 pt-1 text-muted">{footer}</small>;
        controlClassName += ' flex-column align-items-stretch';
    }

    const onKeyDownHandler = (event: any) => {
        if (event.key.toLowerCase() === 'enter') {
            const form = event.target.form;
            if (!form) return;
            const index = [...form].indexOf(event.target);
            if (event.shiftKey) {
                if (index > 0) form.elements[index - 1].focus();
            } else {
                if (index + 1 < form.elements.length) form.elements[index + 1].focus();
            }
            event.preventDefault();
        }
    };

    return (
        <bd.FormRow
            label={!label ? label : typeof label === 'string' ? translate(label) : label}
            labelWidth={labelWidth}
            htmlFor={id}
            className={className}
            width={width}
            maxWidth={maxWidth}
            controlClassName={controlClassName}
        >
            <NumberInput
                id={id}
                type={type}
                className={postfixLabel ? '' : 'w-100'}
                inputClassName={classNames(inputClassName, { 'bd-border-error': meta.error })}
                autoComplete={autoComplete}
                spellCheck={spellCheck}
                autoFocus={autoFocus}
                title={meta.error}
                {...field}
                {...props}
                value={displayValue || ''}
                inputStyle={inputStyle}
                buttonIcon={buttonIcon}
                buttonOnClick={buttonOnClick}
                readOnly={readOnly}
                error={meta.error}
                showErrorLabel={showErrorLabel ?? true}
                onChange={onChangeHandler}
                maxLength={maxLength}
                inputRef={inputRef}
                onKeyDown={handleEnter ? onKeyDownHandler : null}
            />
            {postfixLabel}
        </bd.FormRow>
    );
};
